import { todayStr } from "../../constants/categories";

export default function GithubStyle({
  histMap, completedCount, streak, completionRate,
  calMonth, calYear, monthDays, firstDayOfWeek, monthNames,
  prevMonth, nextMonth, isCurrentMonth,
  selectedDay, setSelectedDay,
  heatmapWeeks,
}) {
  return (
    <>
      {/* GitHub Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px", marginBottom: "20px" }}>
        <div style={{ background: "var(--bg-card)", border: "1px solid #10B98144", borderRadius: "14px", padding: "16px", textAlign: "center" }}>
          <div style={{ fontSize: "28px", fontWeight: "800", color: "#10B981" }}>{completedCount}</div>
          <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "2px" }}>Hoàn thành</div>
        </div>
        <div style={{ background: "var(--bg-card)", border: "1px solid #F59E0B44", borderRadius: "14px", padding: "16px", textAlign: "center" }}>
          <div style={{ fontSize: "28px", fontWeight: "800", color: "#F59E0B" }}>{streak.current_streak}</div>
          <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "2px" }}>Streak</div>
        </div>
        <div style={{ background: "var(--bg-card)", border: "1px solid #7C3AED44", borderRadius: "14px", padding: "16px", textAlign: "center" }}>
          <div style={{ fontSize: "28px", fontWeight: "800", color: "#7C3AED" }}>{streak.longest_streak}</div>
          <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "2px" }}>Kỷ lục</div>
        </div>
      </div>

      {/* Year Heatmap */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "16px", padding: "20px", marginBottom: "20px" }}>
        <div style={{ fontSize: "13px", color: "var(--text-tertiary)", letterSpacing: "1px", marginBottom: "14px" }}>{calYear} — Hành trình của bạn</div>
        <div style={{ overflowX: "auto", paddingBottom: "4px" }}>
          <div style={{ display: "flex", gap: "3px", minWidth: "fit-content" }}>
            {heatmapWeeks.map((week, wi) => (
              <div key={wi} style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                {week.map((day, di) => {
                  if (!day.inYear) return <div key={di} style={{ width: "14px", height: "14px" }} />;
                  const hasChallenge = day.items.length > 0;
                  const isToday = day.date === todayStr;
                  const completedN = day.items.filter(c => c.completed).length;
                  const level = completedN >= 3 ? 4 : completedN >= 2 ? 3 : completedN >= 1 ? 2 : hasChallenge ? 1 : 0;
                  const levelColors = ["var(--bg-inset)", "var(--border-primary)", "#10B98177", "#10B981BB", "#10B981"];
                  return (
                    <div key={di} onClick={() => hasChallenge && setSelectedDay(day.items)}
                      title={`${day.date}${hasChallenge ? ` — ${day.items.length} thử thách` : ""}`}
                      style={{ width: "14px", height: "14px", borderRadius: "2px", cursor: hasChallenge ? "pointer" : "default", background: levelColors[level], border: isToday ? "1px solid var(--text-primary)" : "none", boxSizing: "border-box" }} />
                  );
                })}
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "10px", fontSize: "10px", color: "var(--text-muted)" }}>
          <span>Ít</span>
          <div style={{ width: "12px", height: "12px", borderRadius: "2px", background: "var(--bg-inset)" }} />
          <div style={{ width: "12px", height: "12px", borderRadius: "2px", background: "var(--border-primary)" }} />
          <div style={{ width: "12px", height: "12px", borderRadius: "2px", background: "#10B981", opacity: 0.6 }} />
          <div style={{ width: "12px", height: "12px", borderRadius: "2px", background: "#10B981" }} />
          <span>Nhiều</span>
        </div>
      </div>

      {/* Monthly Calendar - GitHub style */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "16px", padding: "20px", marginBottom: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <button onClick={prevMonth} style={{ background: "none", border: "none", color: "var(--text-tertiary)", cursor: "pointer", fontSize: "18px", padding: "4px 8px" }}>‹</button>
          <div style={{ fontSize: "16px", fontWeight: "700", color: "var(--text-primary)" }}>{monthNames[calMonth]} {calYear}</div>
          <button onClick={nextMonth} style={{ background: "none", border: "none", color: isCurrentMonth ? "var(--border-primary)" : "var(--text-tertiary)", cursor: isCurrentMonth ? "default" : "pointer", fontSize: "18px", padding: "4px 8px" }}>›</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px", textAlign: "center" }}>
          {["CN","T2","T3","T4","T5","T6","T7"].map(d => (
            <div key={d} style={{ fontSize: "10px", color: "var(--text-dim)", padding: "4px 0", fontWeight: "600" }}>{d}</div>
          ))}
          {Array.from({ length: firstDayOfWeek }).map((_, i) => <div key={`e${i}`} />)}
          {Array.from({ length: monthDays }).map((_, i) => {
            const day = i + 1;
            const dateStr = `${calYear}-${String(calMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            const items = histMap[dateStr] || [];
            const hasCompleted = items.some(c => c.completed);
            const hasData = items.length > 0;
            const isToday = dateStr === todayStr;
            const isFuture = dateStr > todayStr;
            const isSelected = Array.isArray(selectedDay) && selectedDay[0]?.date === dateStr;
            const completedN = items.filter(c => c.completed).length;
            return (
              <div key={day} onClick={() => !isFuture && hasData && setSelectedDay(items)}
                style={{ position: "relative", aspectRatio: "1", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "10px", boxSizing: "border-box", cursor: hasData && !isFuture ? "pointer" : "default", fontSize: "13px", fontWeight: isToday ? "800" : "500", color: isFuture ? "var(--border-primary)" : hasCompleted ? "#fff" : isToday ? "var(--text-primary)" : "var(--text-muted)", background: hasCompleted ? "#10B981" : "transparent", border: isToday ? "2px solid var(--text-primary)" : isSelected ? "3px solid #059669" : "2px solid transparent", boxShadow: isSelected ? "0 0 0 2px #10B98155" : "none", transition: "background 0.2s, border-color 0.2s" }}>
                {day}
                {hasCompleted && <div style={{ position: "absolute", bottom: "2px", fontSize: "6px" }}>{completedN > 1 ? `✓${completedN}` : "✓"}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
